import Column from '@components/column'
import Row from '@components/row'
import Skeleton from '@components/skeleton'
import {
  AdditionalImages,
  BookContent,
  BookImages,
} from '@pages/user/allPages/style'

const BookDescriptionLoader = () => {
  return (
    <>
      <BookContent>
        <BookImages>
          <Skeleton height={300} width={'100%'} radius={8} />

          <AdditionalImages>
            <Skeleton height={'100%'} width={60} radius={8} />
            <Skeleton height={'100%'} width={60} radius={8} />
            <Skeleton height={'100%'} width={60} radius={8} />
            <Skeleton height={'100%'} width={60} radius={8} />
          </AdditionalImages>
        </BookImages>

        <Column rowGap={10}>
          <Skeleton height={10} width={250} radius={4} />

          <Row colGap={10}>
            <Skeleton height={20} width={100} radius={4} />
            <Skeleton height={20} width={100} radius={4} />
          </Row>
          <Column rowGap={10}>
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
            <Skeleton height={10} width={'100%'} radius={4} />
          </Column>
        </Column>
      </BookContent>
    </>
  )
}

export default BookDescriptionLoader
